import React from "react";
import { useTranslation } from "react-i18next";
import Styles from "../../../scss/orderHistory.module.scss";

interface IOrderPickupTitlesProps {
    label: string;
    value: number;
}

export function OrderPickupTitles({ label, value }: IOrderPickupTitlesProps) {
    const { t } = useTranslation();

    return <div className={Styles.PickupTitle}>
        <p>{t(label)}</p>
        <div className={Styles.Ring}>
            <p>{value}</p>
        </div>
    </div>
}